import React, { type JSX } from 'react';

interface ThinkingIndicatorProps {
  text?: JSX.Element | string;
  children?: React.ReactNode;
}

export const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = ({ text, children }) => {
  return (
    <div className="thinking-indicator">
      <span>{text ?? children}</span>
      <div className="thinking-dots">
        <div className="thinking-dot"></div>
        <div className="thinking-dot"></div>
        <div className="thinking-dot"></div>
      </div>
    </div>
  );
};